import Vue from "vue";
import Vuex from "vuex";
import axios from "axios"
import config from "./config"
import error from "./error"

import userStore from "./stores/userStore"
import roleStore from "./stores/roleStore"
import categoryStore from "./stores/categoryStore"
import issueStore from "./stores/issueStore"
import articleStore from "./stores/articleStore"
import homePageStore from "./stores/homePageStore"
import resourceGroupStore from "./stores/resourceGroupStore"
import linkStore from "./stores/linkStore"
import floatingBannerStore from "./stores/floatingBannerStore"
import departmentBannerStore from "./stores/departmentBannerStore"
import topBanner from "./stores/topBannerStore"
import shortTermJobStore from "./stores/shortTermJobStore"
import importStore from "./stores/importStore"
import quizStore from "./stores/quizStore"
import systemTheme from "./stores/systemTheme"
import courseStore from "./stores/courseStore"
import eightCentresStore from "./stores/eightCentresStore"
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(sessionStorage.getItem("userInfo")) || {},
    pageTitle: 'login',
    warning: {
      warningMsg: "",
      warningFalg: false,
      button: []
    },
    magazine: {
      magazineFalg: false,
      id: "",
      rnd: ""
    }
  },
  mutations: {
    setPageTitle(state, string) {
      state.pageTitle = string;
    },
    setwarning(state, data) {
      state.warning.warningMsg = data.string;
      state.warning.warningFalg = data.boolean;
      state.warning.button = data.button;
    },
    setmagazine(state, data) {
      state.magazine.magazineFalg = data.boolean;
      state.magazine.id = data.id;
      state.magazine.rnd = data.rnd;
    },
    login(state, userInfo) {
      Vue.set(state, 'userInfo', userInfo);
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  },
  getters: {
    warning: state => state.warning,
  },
  actions: {
    async login(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/login`, data);
          if (result.data.errorCode === 0) {
            let assembleFunction = function (parentObj, list) {
              for (var i = 0; i < list.length; i++) {
                var childObj = list[i];
                if (parentObj.id == childObj.parentId) {
                  if (parentObj.children) {
                    parentObj.children.push(childObj);
                  } else {
                    parentObj.children = [];
                    parentObj.children.push(childObj);
                  }
                  assembleFunction(childObj, list);
                }
              }
            }
            let systemFuncs = result.data.result.systemFuncs;
            var rootObj = { id: 0 };
            assembleFunction(rootObj, systemFuncs);
            result.data.result.systemFuncs = rootObj.children;
            result.data.result.langCode = "en_US";
            context.commit("login", result.data.result);
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () { }
              }]
            })
            resolve(false)
          }
        } catch (err) {
          console.log(err, "错误")
          reject(err)
        }
      })
    }
  },
  modules: {
    userStore: userStore,
    roleStore: roleStore,
    categoryStore: categoryStore,
    issueStore: issueStore,
    articleStore: articleStore,
    homePageStore: homePageStore,
    resourceGroupStore: resourceGroupStore,
    linkStore: linkStore,
    floatingBannerStore: floatingBannerStore,
    departmentBannerStore: departmentBannerStore,
    shortTermJobStore: shortTermJobStore,
    importStore,
    topBanner,
    quizStore,
    courseStore,
    systemTheme,
    eightCentres: eightCentresStore
  }
});
